import React from "react";
import { brl } from "../lib";

const COR = "#7fb0e0";

/* Serviços Adicionais (aditivos) no Signature Book — destaque com etiqueta ADITIVO. */
export function SBAditivos({ itens, base }) {
  const aprovados = itens.filter(o => o.status !== "pendente");
  const totalAprov = aprovados.reduce((s, o) => s + Number(o.valor || 0), 0);
  return (
    <div data-testid="sb-aditivos" style={{
      marginTop: 18, padding: "16px 18px", background: "linear-gradient(135deg, rgba(127,176,224,0.10) 0%, rgba(127,176,224,0.03) 100%)",
      border: `1px solid rgba(127,176,224,0.40)`, borderLeft: `3px solid ${COR}`,
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
        <div style={{ fontSize: 10, letterSpacing: ".25em", textTransform: "uppercase", color: COR, fontWeight: 600 }}>Serviços adicionais ao contrato</div>
        {base > 0 && <div style={{ fontSize: 11, color: "var(--ink-3)" }} data-testid="sb-aditivos-base">Contrato original {brl(base)}</div>}
      </div>
      {itens.map((o, i) => {
        const pend = o.status === "pendente";
        return (
          <div key={o.id || i} data-testid={`sb-aditivo-${i}`} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 14, padding: "10px 0", borderTop: i ? "1px solid rgba(127,176,224,0.15)" : "none" }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".2em", color: "#0d0d0f", background: COR, padding: "2px 7px", borderRadius: 2 }}>ADITIVO</span>
                <span style={{ color: "var(--ink)", fontSize: 14, fontFamily: "'Fraunces',serif", fontStyle: "italic" }} data-testid={`sb-aditivo-nome-${i}`}>{o.nome}</span>
                {pend && <span style={{ fontSize: 9, letterSpacing: ".15em", textTransform: "uppercase", color: "#d4b27a", border: "1px solid rgba(212,178,122,0.5)", padding: "1px 6px" }} data-testid={`sb-aditivo-pendente-${i}`}>aguardando aprovação</span>}
              </div>
              {o.descricao && <div style={{ fontSize: 12, color: "var(--ink-3)", marginTop: 4, overflowWrap: "anywhere" }}>{o.descricao}</div>}
            </div>
            <div style={{ fontVariantNumeric: "tabular-nums", color: pend ? "var(--ink-3)" : "var(--ink)", fontWeight: 600, whiteSpace: "nowrap" }} data-testid={`sb-aditivo-valor-${i}`}>{brl(o.valor)}</div>
          </div>
        );
      })}
      <div style={{ marginTop: 6, paddingTop: 10, borderTop: `1px solid rgba(127,176,224,0.3)`, display: "flex", justifyContent: "space-between", fontSize: 12, color: "var(--ink-2)" }}>
        <span>Aditivos aprovados (já somados ao valor total)</span>
        <strong style={{ color: COR }} data-testid="sb-aditivos-total">{brl(totalAprov)}</strong>
      </div>
    </div>
  );
}
